"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useListingsStore = void 0;
const pinia_1 = require("pinia");
const core_1 = require("@vueuse/core");
const Listings_1 = __importDefault(require("../src/api/Listings"));
const get_1 = __importDefault(require("lodash/get"));
exports.useListingsStore = (0, pinia_1.defineStore)('listings', {
    state: () => {
        return {
            view: (0, core_1.useStorage)('listingsLayout', 'grid'),
            category: null,
            level: null,
            type: null,
            tag: null,
            listings: [],
            loadingListings: true,
            page: 0,
            lastPage: null,
            lastListing: false,
        };
    },
    actions: {
        loadMore() {
            return __awaiter(this, void 0, void 0, function* () {
                this.page++;
                this.loadingListings = true;
                Listings_1.default.fetchListings(this.page, this.level || this.category, this.type, this.tag)
                    .then((response) => {
                    const data = (0, get_1.default)(response, 'data.data', []);
                    const meta = (0, get_1.default)(response, 'data.meta', []);
                    this.lastPage = meta.last_page;
                    this.listings = this.listings.concat(data);
                })
                    .catch(e => {
                    console.error(e);
                })
                    .then(() => {
                    this.loadingListings = false;
                });
                if (this.lastPage && this.page >= this.lastPage) {
                    this.loadingListings = false;
                    this.lastListing = true;
                    return;
                }
            });
        },
        resetListings() {
            this.listings = [];
            this.page = 0;
        },
    }
});
